import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { CurriculumTreeConceptInterface } from '../+models';

export const CURRICULUM_TREE_CONCEPT_SERVICE_TOKEN = new InjectionToken('CurriculumTreeConceptServiceInterface');

export interface CurriculumTreeConceptServiceInterface {
  getAllForUser(userId: number): Observable<CurriculumTreeConceptInterface[]>;
}
